// extracted by mini-css-extract-plugin
export default {"text-overflow":"_2FrwF","flex-between":"_3UwfK","flex-align":"_12-4f","editableCheckbox":"_17rvc"};